import {helpCenterUrl} from '../../../store/stateless/navigationActions';

export const LIVE_DASHBOARD_MIN_OUTER_WIDTH = 700; // px = 676 + 12 * 2
export const LIVE_DASHBOARD_MAX_WIDTH = 1440; // px

export const LIVE_DASHBOARD_REDUCED_GAP_BREAKPOINT_VIEWPORT_WIDTH = 1100; // px

// The following breakpoint applies to the popped-out layout.
// When docked, you should add P1's width.
export const LIVE_DASHBOARD_2_BY_2_HEADLINE_METRICS_BREAKPOINT_VIEWPORT_WIDTH = 1200; // px

export const LIVE_DASHBOARD_MAX_INBOXES = 30;
export const LIVE_DASHBOARD_MAX_TEAMMATES = 100;

// The maximum number of inboxes selected by default based on the user's P1.
export const LIVE_DASHBOARD_MAX_DEFAULT_INBOXES = 5;

export const LIVE_DASHBOARD_HELP_CENTER_URL = `${helpCenterUrl}/en/articles/1146752`;
export const LIVE_DASHBOARD_METRICS_HELP_CENTER_URL = `${helpCenterUrl}/en/articles/1147968`;

export const LIVE_DASHBOARD_AUTO_REFRESH_PERIOD_MS = 60_000;
